<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="pointer" role="tab" v-b-toggle="'assess_' + assessment.id">
                <div class="row">
                    <div class="col-8">
                        <h5 v-if="assessment.object_title.length > 25" class="font-18">{{assessment.object_title.substring(0,25) + '...'}} ({{assessment.object_id}})</h5>
                        <h5 v-else class="font-18">{{assessment.object_title}} ({{assessment.object_id}})</h5>
                        <h5 class="font-18">{{assessment.nickname}}</h5>
                    </div>
                    <div class="col-4">
                        <div class="text-right mm-color">
                            <stars-component :stars="assessment.stars_average"/>
                        </div>
                        <div class="text-right mt-1">
                            <p class="small text-muted m-0">{{assessment.datum}}</p>
                        </div>
                    </div>
                </div>
            </b-card-header>
            <b-collapse :id="'assess_' + assessment.id" accordion="my-accordion" role="tabpanel" @show="getAnswer">
                <b-card-body>
                  <b-card-text class="row">
                        <div class="col-12 col-md-4 text-center">
                            <strong>Abwicklung</strong> <br>
                            <stars-component :stars="assessment.stars_abwicklung" class="mm-color"/>
                        </div>
                        <div class="col-12 col-md-4 text-center">
                            <strong>Service</strong> <br>
                            <stars-component :stars="assessment.stars_service" class="mm-color"/>
                        </div>
                        <div class="col-12 col-md-4 text-center">
                            <strong>Preisleistung</strong> <br>
                            <stars-component :stars="assessment.stars_preisleistung" class="mm-color"/>
                        </div>
                    </b-card-text>
                    <hr/>
                    <b-card-text>

                        <h6>
                            <strong>Kommentar des Mieters</strong>
                        </h6>
                        <p v-html="assessment.message"></p>
                        <div class="row">
                            <div class="col-md-7">
                                <div v-if="answer">
                                    <h6><strong>Ihre Antwort</strong></h6>
                                    <p>{{answer.answer}}</p>
                                    <div class="small text-muted">{{answer.updated_at}}</div>
                                </div>
                            </div>
                            <div class="col-md-5 mb-1">
                                <div class=" btn-group float-right">
                                  <button
                                      class="btn btn-width-fixed"
                                      :class="{'btn-success': !show_answer_input, 'btn-secondary': show_answer_input , 'btn-width-fixed-edit btn-margin-bottom': answer}"
                                      @click="show_answer_input = !show_answer_input">
                                      <span v-if="!show_answer_input">
                                          <template v-if="answer">Bearbeiten</template>
                                          <template v-else>Antworten</template>
                                      </span>
                                      <span v-else>Ausblenden</span>
                                  </button>
                                  <button class="btn btn-danger" v-if="answer" @click="deleteAnswer" title="Antwort löschen"
                                    :class="{'btn-margin-bottom' : answer}">
                                      <font-awesome-icon icon="trash-alt"/>
                                  </button>
                            </div>
                            </div>

                        </div>

                        <div v-show="show_answer_input" class="mb-5">
                            <textarea v-model.trim="answer_input" class="form-control" placeholder="Schreiben Sie Ihre Antwort"></textarea>
                            <button
                                class="btn btn-width-fixed btn-success float-right mt-1 "
                                @click="saveAnswer"
                                v-b-tooltip.hover
                                title="Schicken"
                            >
                                Speichern
                            </button>
                        </div>
                    </b-card-text>
                    <hr>
                    <b-card-text class="row">
                        <div class="col-12 col-md-6">
                            <div>
                                <strong>Status:</strong>
                                <div class="ml-2 d-inline" v-if="assessment.status == 1">
                                    <font-awesome-icon icon="eye"/>
                                    Veröffentlicht
                                </div>
                                <div class="ml-2 d-inline" v-else>
                                    <font-awesome-icon icon="eye-slash"/>
                                    Nicht veröffentlicht
                                </div>
                            </div>
                            <!--<div>
                                <strong>Verstoß gemeldet:</strong>
                                <div class="ml-2 d-inline" v-if="assessment.report == 1">
                                    <font-awesome-icon icon="check"/>
                                    Ja
                                </div>
                                <div class="ml-2 d-inline" v-else>
                                    <font-awesome-icon icon="times"/>
                                    Nein
                                </div>
                            </div>
                            <div>
                                <strong>Gesperrt:</strong>
                                <div class="ml-2 d-inline" v-if="assessment.report == 1">
                                    <font-awesome-icon icon="lock"/>
                                    Ja
                                </div>
                                <div class="ml-2 d-inline" v-else>
                                    <font-awesome-icon icon="lock-open"/>
                                    Nein
                                </div>
                            </div>-->
                        </div>
                        <div class="col-12 col-md-6 text-center mt-2 mt-md-0">
                            <button class="btn btn-success btn-width-fixed float-right mb-1" @click="report" v-if="assessment.report == 0">Bewertung melden</button>
                            <div class="alert alert-info small btn-width-fixed float-right" v-else>Bewertung erfolgreich gemeldet</div>
                            <a v-if="object" :href=object.url target="_blank">
                              <button class="btn btn-success btn-width-fixed float-right">Inserat Vorschau <font-awesome-icon icon="eye"/></button>
                            </a>
                        </div>
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
        <b-modal ref="report_preview" title="Möchten Sie diese Bewertung wirklich melden?" size="lg">

          <div class="m-4 row">
            <select v-model="report_reason" class="form-control col-md-4">
                <option value=""> Grund auswählen </option>
                <option value="Spam">Spam</option>
                <option value="Keine Vermietung">Keine Vermietung</option>
                <option value="Andere">Andere</option>
            </select>
          </div>
          <template slot="modal-footer">
                <b-button variant="secondary" @click="clearModal">Abbrechen</b-button>
                <b-button variant="danger" @click="submitReport">Bewertung melden</b-button>
          </template>
        </b-modal>
    </div>
</template>

<script>
    import StarsComponent  from '../shared/Stars';
    import ObjectComponent from '../object/Object'
    export default {
        data() {
            return {
                show_answer_input: false,
                object: null,
                answer_input: '',
                answer: null,
                one_request: 0,
                report_reason : ''
            }
        },
        props: ['assessment'],
        components: {
            StarsComponent,
            ObjectComponent
        },
        beforeMount() {
            if(!this.object){
                this.$store.state.loading = true;
                this.$http.get('/ObjectApi/getObject?id=' + this.assessment.object_id).then(response => {
                    this.object = JSON.parse(response.data);
                }).catch(error => {
                    console.log(error);
                }).then(() => {
                    this.$store.state.loading = false;
                })
            }
        },
        methods: {
            getAnswer() {
                if(this.one_request == 0){
                    this.$store.state.loading = true;
                    this.$http.get('/AssessmentApi/getAnswer/?id=' + this.assessment.id).then(response => {
                        if(JSON.parse(response.data)){
                            this.answer        = JSON.parse(response.data);
                            this.answer_input  = this.answer.answer;
                        }
                    }).catch(error => {
                        console.log(error);
                    }).then(() => {
                        this.$store.state.loading = false;
                        this.one_request++;
                    });
                }
            },
            saveAnswer() {
                if( (!this.answer || this.answer.answer != this.answer_input) && this.answer_input != ''){
                    this.$store.state.loading = true;
                    this.$http.post('/AssessmentApi/saveAnswer?id=' + this.assessment.id, {answer: this.answer_input}).then(response => {
                        this.answer = JSON.parse(response.data);
                        this.show_answer_input = false;
                    }).catch(error => {
                        console.log(error);
                    }).then(() => {
                        this.$store.state.loading = false;
                    });
                }
            },
            clearModal() {
            this.$refs.report_preview.hide();
            },
            report() {
                this.$refs.report_preview.show();
            },
            submitReport(){
              this.$store.state.loading = true;
              this.$http.put('/AssessmentApi/reportAssessment?id=' + this.assessment.id + '&reason=' + this.report_reason).then(response => {
                  this.$store.state.loading = false;
                  this.assessment.report    = 1;
                  this.$bvToast.toast(response.data, {
                      variant: 'info',
                      title: 'Benachrichtigung'
                  });
                  this.$refs.report_preview.hide();
              }).catch(error => {
                  console.log(error);
                  this.$store.state.loading = false;
              });
            },
            deleteAnswer() {
                this.$bvModal.msgBoxConfirm('Möchten Sie Ihre Antwort wirklich löschen?', {
                    okVariant: 'danger',
                    cancelTitle: 'Abbrechen',
                    okTitle: 'Bestätigen'
                }).then(val => {
                    if(val) {
                        this.$store.state.loading = true;
                        this.$http.delete('/AssessmentApi/deleteAssessment?id=' + this.assessment.id).then(response => {
                            this.$store.state.loading = false;
                            this.answer               = null;
                            this.answer_input         = '';
                            this.$bvToast.toast(response.data, {
                                variant: 'info',
                                title: 'Benachrichtigung'
                            });
                        }).catch(error => {
                            console.log(error);
                            this.$store.state.loading = false;
                        });
                    }
                });
            }
        },
    }
</script>

<style scoped>
textarea{
    resize: none;
    height: 150px;
}
.btn-width-fixed{
  min-width: 280px;
}
.btn-width-fixed-edit{
  min-width: 240px;
}
.btn-margin-bottom{
  /*margin-bottom: 4.2rem !important;*/
;
}
</style>
